<!-- 第三方车场车辆出场上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "../../commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KNTYVWC",
                "carCode": "粤EXX123",
                "cardCode": "",
                "needPayQrCode": "",
                "parkingCode": "",
                "couponList": [
                    {
                        "couponName": "三小时优惠",
                        "couponCode": "xxxx",
                        "reliefType": "0",
                        "faceValue": "10",
                        "useRule": "",
                        "maxReliefValue": "",
                        "extraProperty": ""
                    }
                ]
            },
            responseCode: {
	"data": {
		
	},
	"resultCode": 0,
	"message": "业务成功",
	"status": 1
},
            infoData: {
                explain: "第三方车场缴费系统请求智慧停车开放平台，上报车辆出场数据",
                t_url: this.commonUrls.test + "upThirdParkCarOut",
                p_url: this.commonUrls.prod + "upThirdParkCarOut",
                precondition: "SDK上报和http方式上报勿同时使用",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",                
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'data', info2: '数据', info3: 'JSONObject', info4: '上报数据' },
                    ]
                }, {
                    titleName: 'data',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carNumber', info2: '是', info3: 'String', info4: '车牌号码' },
                        { info1: 'inTime', info2: '是', info3: 'Long', info4: '进场时间（时间戳）' },
                        { info1: 'outTime', info2: '是', info3: 'Long', info4: '进场时间（时间戳）' },
                        { info1: 'carType', info2: '是', info3: 'Integer', info4: '车型,例：大车' },
                        { info1: 'cType', info2: '是', info3: 'String', info4: '进场类型,例：通道扫牌' },
                        { info1: 'outType', info2: '是', info3: 'String', info4: '出场类型,例：通道扫牌' },
                        { info1: 'payType', info2: '是', info3: 'String', info4: '支付类型,例：通道扫牌' },
                        { info1: 'uid', info2: '否', info3: 'String', info4: '入场收费员id' },
                        { info1: 'outUid', info2: '否', info3: 'String', info4: '出场收费员id' },
                        { info1: 'orderId', info2: '否', info3: 'String', info4: '订单记录号(车辆在停车场停车唯一订单编号，支持数字 字母 _ )' },
                        { info1: 'emptyPlot', info2: '否', info3: 'Integer', info4: '空闲车位数' },
                        { info1: 'inChannelId', info2: '否', info3: 'String', info4: '进场通道' },
                        { info1: 'outChannelId', info2: '否', info3: 'String', info4: '进场通道' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'amountReceivable', info2: '是', info3: 'Decimal', info4: '应收金额' },
                        { info1: 'reduceAmount', info2: '是', info3: 'Decimal', info4: '减免金额' },
                        { info1: 'total', info2: '是', info3: 'Decimal', info4: '实时订单金额（不包含已预付、已减免的部分' },
                        { info1: 'electronicPrepay', info2: '是', info3: 'Decimal', info4: '电子预付' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForBolian/upThirdParkCarOut.vue